import React, { ReactElement } from 'react';
import { Labeled } from 'react-admin';

import { Box } from '@mui/material';

import InfoPopover from '../../layout/InfoPopover';

interface FieldBoxProps {
  title: string;
  description: string;
  children: ReactElement;
  inline?: boolean;
}

const FieldBox = ({
  title,
  description,
  children,
  inline = false,
}: FieldBoxProps) => (
  <Labeled
    label={(
      <Box display="flex" alignItems="center" gap={1} component="span">
        {title}
        <InfoPopover title={title} content={description} />
      </Box>
    )}
    sx={inline ? {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 2,
      justifyContent: 'space-between',
    } : {}}
  >
    {children}
  </Labeled>
);

export default FieldBox;
